import { toast } from 'sonner';
import {
  DEFAULT_DOSSIER_FIELD_FLAGS,
  type DossierFieldFlags,
} from '../../lib/dossiers/dossierFields';
import {
  useDossierFieldFlags,
  useUpdateDossierFieldFlags,
} from '../../hooks/queries/useCabinetSettings';
import { cn } from '../../lib/cn';

const OPTIONS: { key: keyof DossierFieldFlags; label: string; hint: string }[] = [
  {
    key: 'prescription',
    label: 'Prescription',
    hint: 'Date de prescription, calendrier, rappels et agenda Google.',
  },
  {
    key: 'legalAid',
    label: 'Aide juridictionnelle',
    hint: 'Mention « AJ » sur les dossiers et colonne du registre.',
  },
];

export function DossierFieldFlagsSection() {
  const { data: flags = DEFAULT_DOSSIER_FIELD_FLAGS } = useDossierFieldFlags();
  const update = useUpdateDossierFieldFlags();

  function toggle(key: keyof DossierFieldFlags, checked: boolean) {
    const next: DossierFieldFlags = { ...flags, [key]: checked };
    update.mutate(next, {
      onError: (err) => {
        toast.error(
          err instanceof Error ? err.message : 'Impossible d’enregistrer le réglage',
        );
      },
    });
  }

  return (
    <section className="rounded-cime border border-neutral-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-cime-text-primary">Notions suivies</h2>
        <p className="text-sm text-cime-text-muted mt-1">
          Une case décochée disparaît de toute l’application, rappels compris. Rien n’est
          effacé : en la recochant, les données reviennent.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        {OPTIONS.map(({ key, label, hint }) => {
          const checked = flags[key];
          return (
            <label
              key={key}
              htmlFor={`dossier-field-${key}`}
              className={cn(
                'flex items-center gap-3 rounded-md border p-3 cursor-pointer',
                checked ? 'border-cime-primary bg-cime-primary/5' : 'border-neutral-200',
              )}
            >
              <input
                id={`dossier-field-${key}`}
                type="checkbox"
                className="h-4 w-4 accent-cime-primary"
                checked={checked}
                disabled={update.isPending}
                onChange={(e) => toggle(key, e.target.checked)}
              />
              <span>
                <span className="block text-sm font-medium text-cime-text-primary">{label}</span>
                <span className="block text-xs text-cime-text-muted">{hint}</span>
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
